import React, { useState , useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer , toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {axiosApiInstance} from '../../../../services/axios';
import Form from '../../../common/forms/Form';
import Loading from '../../../common/loading/Loading';


const BlogSetting = () => {

    const Navigate = useNavigate();

    const[loading , setLoading] = useState(false);
    const [loadingForm , setLoadingForm] = useState(false);
    const [blogSetting , setBlogSetting ] = useState({});
    const [ form , setForm ]= useState({formItems : [
        {
            inputType: "select-blog-multi-search-api",
            config: {
                options : [],
                label: 'Favorite Index Blog',
                name: "favoriteIndex",
                containerClasses : 'w-full z-[50000000]',
                isMulti : false
            },
            value: [] ,
            valueFull : [] ,
            validation: {
                notEmptyArray : true
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "select-blog-multi-search-api",
            config: {
                options : [],
                label: 'Most Popular',
                name: "mostPopular",
                containerClasses : 'w-full z-[50000000]',
                isMulti : true
            },
            value: [] ,
            valueFull : [] ,
            validation: {
                notEmptyArray : true
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "select-blog-multi-search-api",
            config: {
                options : [],
                label: 'Favorite Categories',
                name: "favoriteCats",
                containerClasses : 'w-full z-[50000000]',
                isMulti : true
            },
            value: [] ,
            valueFull : [] ,
            validation: {
                notEmptyArray : true
            },
            valid: false,
            errorMsg: "",
            used: false
        },
    ]});


    useEffect(()=>{

        const getBlogSetting = async()=>{
            const res = await axiosApiInstance.get(`/admin/blog-setting` );
            if(res.data.status === 'success'){

                if(res.data.data.blogSetting){

                    setForm( {
                        formItems: [
                            {
                                inputType: "select-blog-multi-search-api",
                                config: {
                                    options : [],
                                    label: 'Favorite Index Blog',
                                    name: "favoriteIndex",
                                    containerClasses : 'w-full z-[50000000]',
                                    isMulti : false
                                },
                                value: [res.data.data.blogSetting?.favoriteIndex?.id] ,
                                valueFull : [{
                                    ...res.data.data.blogSetting?.favoriteIndex
                                }] ,
                                validation: {
                                    notEmptyArray : true
                                },
                                valid: false,
                                errorMsg: "",
                                used: false
                            },
                            {
                                inputType: "select-blog-multi-search-api",
                                config: {
                                    options : [],
                                    label: 'Most Popular',
                                    name: "mostPopular",
                                    containerClasses : 'w-full z-[50000000]',
                                    isMulti : true
                                },
                                value: res.data.data.blogSetting?.mostPopular.map(item=>(item.id)) ,
                                valueFull : [...res.data.data.blogSetting?.mostPopular] ,
                                validation: {
                                    notEmptyArray : true
                                },
                                valid: false,
                                errorMsg: "",
                                used: false
                            },
                            {
                                inputType: "select-blog-cat",
                                config: {
                                    options :  res.data.data.blogCats ,
                                    label: 'Favorite Categories',
                                    name: "favoriteCats",
                                    containerClasses : 'w-full'
                                },
                                value: [] ,
                                validation: {
                                    notEmptyArray : true
                                },
                                valid: false,
                                errorMsg: "",
                                used: false
                            },
                    ]
                    });
                }
                
            }else if(res.data.status === 'error'){
                toast.error(res.data.msg);
            }

            setLoading(false);

        }

        getBlogSetting();

    } , []);
        


    const handleSubmitForm = async(formData)=>{
        try{

            setLoadingForm(true);
            
            // اگر key به صورت آرایه بود، به رشته کاما جدا تبدیل کن
            for (const key in formData) {
                if (Array.isArray(formData[key])) {
                    formData[key] = formData[key].join(',');
                }
            }

            const {data} = await axiosApiInstance.post('/admin/blog-setting/update' , formData) ;
            if(data.status === 'success'){
                setLoadingForm(false); 
                toast.success('Blog setting apply successfull');
                //Navigate('/blog/setting');
    
            }else if(data.status == 'error'){
                setLoadingForm(false);
                toast.error(data.msg);
            }

        }catch(err){
            console.log(err);
            toast.error(err.response.data.data.msg || 'Something in wrong');
        }
    }

    return (
        <>
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />


            <div className="container mx-auto p-3 ">
                <div className='bg-white-100 dark:bg-dark-100 p-3 rounded-md text-[0.9rem] font-normal flex flex-col justify-center items-start shadow-my dark:shadow-none '>

                    <div className='w-full flex justify-start items-center mb-5'>
                        <svg className='w-2 h-2 fill-gray-700 dark:fill-white-100 mr-2' viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="50" />
                        </svg>
                        <span className='text-gray-700 text-xl font-extrabold'>Blog Setting</span>
                    </div>
                    {
                        loading ?
                        (
                            <Loading/>

                        )
                        :
                        (
                            <div className='w-full dark:bg-dark-100 p-3 mb-2 rounded-md text-[0.9rem] font-normal flex flex-col justify-center items-start shadow-my dark:shadow-none '>
                                <Form initForm={form} submit={handleSubmitForm} loading={loadingForm} submitTitle={'Apply'}/>
                            </div>

                        )

                    }
                   
                </div>
                     
            </div>
        </>
    )

}

export default BlogSetting ;
